import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
var failedParticipantIds = new Set();
export function TeamLogo(props) {
    var participantId = props.participantId;
    var className = props.className || '';
    var _a = useState(function () { return !participantId || failedParticipantIds.has(String(participantId)); }), hasError = _a[0], setHasError = _a[1];
    if (hasError) {
        return null;
    }
    return (_jsx("img", { className: className, src: "https://statistics.bcapps.org/images/e/s/0/" + participantId + ".png", alt: "", width: "18", height: "18", loading: "lazy", onError: function () {
            failedParticipantIds.add(String(participantId));
            setHasError(true);
        } }, void 0));
}
